import { ComponentType, ReactNode, useCallback, useState } from 'react'
import { useNavigate } from 'react-router'

import { BottomSheet } from '@/components/ui/bottom-sheet'
import { DOMAIN_LABELS } from '@/lib/domain-labels'
import { MUSIC_DOMAIN } from '@/pages/music/constants'
import { useAppStore } from '@/store/useAppStore'

type DomainSelectorProps = {
  /** BottomSheetを開くトリガー */
  children: (open: () => void) => ReactNode
  /** ドメインとアイコンのマッピング */
  iconMap: Record<string, ComponentType | (() => ReactNode)>
}

export const DomainSelector = ({ children, iconMap }: DomainSelectorProps) => {
  const navigate = useNavigate()
  const accessibleDomains = useAppStore((state) => state.accessibleDomains)
  const [open, setOpen] = useState(false)

  const handleSelect = useCallback(
    (domain: string) => {
      setOpen(false)
      navigate(`/p?domain=${domain}`)
    },
    [navigate],
  )

  return (
    <>
      {children(() => setOpen(true))}
      <BottomSheet title="コンテンツを選択" open={open} onOpenChange={setOpen} snapPoints={[0.6]}>
        <div className="space-y-1 px-4">
          {accessibleDomains
            .filter((domain) => domain !== MUSIC_DOMAIN)
            .map((domain) => {
              const Icon = iconMap[`/p?domain=${domain}`]
              return (
                <button
                  key={domain}
                  onClick={() => handleSelect(domain)}
                  className="flex w-full items-center gap-3 rounded-lg px-3 py-3 text-left hover:bg-accent"
                >
                  {Icon && (
                    <div className="flex h-8 w-8 items-center justify-center [&_svg]:size-6!">
                      <Icon />
                    </div>
                  )}
                  <span className="text-sm font-medium">{DOMAIN_LABELS[domain] ?? domain}</span>
                </button>
              )
            })}
        </div>
      </BottomSheet>
    </>
  )
}
